import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2021-2021 semantics GmbH
//  Date      : $Date: 2026-03-17 17:46:59 +0100 (Tue, 17 Mar 2026) $
//  Author    : Andreas Hesse
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 161639 $
//  Purpose   : Analytics and Session Jobs Dialogs
// =============================================================================
// ---Third-party imports
import React from 'react';
import log from 'uix/logging';
import { Button, Item, Segment, Divider } from 'semantic-ui-react';
import { useSelector } from 'uix/hooks';
import { Sel } from 'uix/registries';
import { HelpDialog } from 'uix/help/dialog';
import { sectionGroupsFromSpec, SpecSections, useEditing } from 'uix/job/components';
import styles from 'uix/job/styles.css';
const filterSpec = (spec, filter)=>{
    let res = {};
    for(const key in spec){
        const vals = filter[key];
        if (vals) {
            res[key] = spec[key].filter((o)=>vals.includes(o.name));
        }
    }
    return res;
};
const SimpleJobDlg = ({ open, spec, params, closeDialog, startJob, name, wikiident, filter })=>{
    let i18n = useSelector(Sel.i18n);
    let [edited, setEditValue, resetEdited] = useEditing(params);
    if (!open) {
        return null;
    }
    wikiident = wikiident || 'help/job/' + name.toLowerCase();
    let newspec = filterSpec(spec, filter);
    // log.x(newspec)
    let sections = sectionGroupsFromSpec(newspec);
    // log.x(sections)
    let buttons = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                content: i18n.get('Start'),
                color: "green",
                floated: "right",
                onClick: ()=>{
                    startJob(name, edited);
                    closeDialog();
                }
            }),
            /*#__PURE__*/ _jsx(Button, {
                content: i18n.get('Cancel'),
                color: "red",
                floated: "right",
                onClick: closeDialog
            })
        ]
    });
    // setup Options for starting a parametrized job
    let options = /*#__PURE__*/ _jsx(Item.Content, {
        className: styles.jobinfoPane,
        style: {
            paddingLeft: 0
        },
        children: sections.map((group, i)=>/*#__PURE__*/ _jsx("div", {
                style: {
                    flex: '1',
                    paddingLeft: i > 0 ? '10px' : null
                },
                children: /*#__PURE__*/ _jsx(SpecSections, {
                    jobName: name,
                    sections: group,
                    edited: edited,
                    onEdit: setEditValue,
                    resetEdited: resetEdited
                })
            }, i))
    });
    return /*#__PURE__*/ _jsx(HelpDialog, {
        name: name,
        wikiident: wikiident,
        buttons: buttons,
        icon: "cog",
        closeOnEsc: true,
        header: name,
        onClose: closeDialog,
        children: /*#__PURE__*/ _jsxs(Item, {
            className: "job",
            children: [
                /*#__PURE__*/ _jsx(Segment, {
                    basic: true,
                    children: i18n.span(name + '_hint')
                }),
                /*#__PURE__*/ _jsx(Divider, {}),
                /*#__PURE__*/ _jsx(Segment, {
                    basic: true,
                    children: options
                })
            ]
        })
    });
};
export const AccessStatsJob = {
    dialog: ({ open, spec, params, closeDialog, startJob })=>{
        const name = 'AccessStatsJob';
        const filter = {
            '': [
                'timelimit'
            ],
            filter: [
                'dateFrom',
                'dateUntil',
                'mode'
            ],
            multicore: [
                'cores'
            ],
            job: [
                'external'
            ]
        };
        return /*#__PURE__*/ _jsx(SimpleJobDlg, {
            open: open,
            spec: spec,
            params: params,
            closeDialog: closeDialog,
            startJob: startJob,
            name: name,
            filter: filter
        });
    }
};
export const AnalyzeSessionHistoryJob = {
    dialog: ({ open, spec, params, closeDialog, startJob })=>{
        const name = 'AnalyzeSessionHistoryJob';
        const filter = {
            '': [
                'compactSessionCount',
                'limit'
            ],
            job: [
                'external'
            ]
        };
        return /*#__PURE__*/ _jsx(SimpleJobDlg, {
            open: open,
            spec: spec,
            params: params,
            closeDialog: closeDialog,
            startJob: startJob,
            name: name,
            filter: filter
        });
    }
};
export const PurgeSessionData = {
    dialog: ({ open, spec, params, closeDialog, startJob })=>{
        const name = 'PurgeSessionData';
        const filter = {
            '': [
                'remove_localhost',
                'shrink'
            ],
            job: [
                'external'
            ]
        };
        return /*#__PURE__*/ _jsx(SimpleJobDlg, {
            open: open,
            spec: spec,
            params: params,
            closeDialog: closeDialog,
            startJob: startJob,
            name: name,
            filter: filter
        });
    }
};
export const SessionMaintenance = {
    dialog: ({ open, spec, params, closeDialog, startJob })=>{
        const name = 'SessionMaintenance';
        const filter = {
            '': [
                'resolve_all',
                'flushLocal'
            ],
            job: [
                'external'
            ]
        };
        return /*#__PURE__*/ _jsx(SimpleJobDlg, {
            open: open,
            spec: spec,
            params: params,
            closeDialog: closeDialog,
            startJob: startJob,
            name: name,
            filter: filter
        });
    }
};
